import { z } from "zod";

const smartyErrorTypeValues = ["ADDRESS_VALIDATION_FAILED", "ADDRESS_VALIDATION_FAILED_RAW"] as const;

const smartyErrorTypeSchema = z.enum(smartyErrorTypeValues);
const SmartyErrorType = smartyErrorTypeSchema.enum;
type SmartyErrorType = z.infer<typeof smartyErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type SmartyErrors =
  | {
      errorType: typeof SmartyErrorType.ADDRESS_VALIDATION_FAILED;
      data: {
        input: {
          countryCode: string;
          administrativeArea: string;
          subAdministrativeArea?: string;
          locality: string;
          addressLine1: string;
          addressLine2?: string;
          postalCode?: string;
        };
      };
    }
  | {
      errorType: typeof SmartyErrorType.ADDRESS_VALIDATION_FAILED_RAW;
      data: {
        rawAddress: string;
      };
    };

export const smartyErrorDetails: Record<SmartyErrorType, ErrorDetails> = {
  [SmartyErrorType.ADDRESS_VALIDATION_FAILED]: {
    sentryDescription: "Smarty address validation returned no result",
  },
  [SmartyErrorType.ADDRESS_VALIDATION_FAILED_RAW]: {
    sentryDescription: "Smarty raw address validation returned no result",
  },
};
